import { useState } from "react";
import { ModalCrearCliente } from "../PefilCliente/ModalCrearCliente/ModalCerearCliente";
import { ModalCrearEmpresa } from "../Empresa/ModalCrearEmpresa";

export const UnificarModales = ({functions}) => {
    const [openModalCrearCliente, setOpenModalCrearCliente] = useState(false);
    const [openModalCrearEmpresa, setOpenModalCrearEmpresa] = useState(false);

    const handleRowClickCrearCliente = () => {
        setOpenModalCrearCliente(true);
    };

    const handleCloseModalCrearCliente = () => {
        setOpenModalCrearCliente(false);
    };

    const handleRowClickCrearEmpresa = () => {
        setOpenModalCrearEmpresa(true);
    };

    const handleCloseModalCrearEmpresa = () => {
        setOpenModalCrearEmpresa(false);
    };

    return (
        <>
            <div style={{ display: "flex", gap: "10px" }}>
                <button type="buttom" className="btn-shadow btn btn-dark" onClick={handleRowClickCrearCliente}>
                    Crear Clientes
                </button>
                <button type="buttom" className="btn-shadow btn btn-dark" onClick={handleRowClickCrearEmpresa}>
                    Crear Empresa
                </button>
            </div>
            {openModalCrearCliente && <ModalCrearCliente functions={functions} open={true} onClose={handleCloseModalCrearCliente} />}
            {openModalCrearEmpresa && <ModalCrearEmpresa functions={functions} open={true} onClose={handleCloseModalCrearEmpresa} />}
        </>
    );
};
